import React from 'react';
import ReactDOM from 'react-dom/client';
import TurnOverlay from './TurnOverlay';

let currentContainer = null;
let currentRoot = null;

export function showTurnOverlay(phase, factionIconUrl, playerColor, skinId, onHidden) {
  // Destroy any existing overlay immediately
  if (currentContainer) {
    if (currentRoot) {
      currentRoot.unmount();
      currentRoot = null;
    }
    if (currentContainer.parentNode) {
      currentContainer.parentNode.removeChild(currentContainer);
    }
    currentContainer = null;
  }

  const container = document.createElement('div');
  document.body.appendChild(container);
  currentContainer = container;

  const root = ReactDOM.createRoot(container);
  currentRoot = root;

  const onComplete = () => {
    if (currentContainer === container) {
      root.unmount();
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
      currentContainer = null;
      currentRoot = null;
      onHidden?.();
    }
  };

  root.render(
    <TurnOverlay
      phase={phase}
      factionIconUrl={factionIconUrl}
      playerColor={playerColor}
      skinId={skinId}
      onComplete={onComplete}
    />
  );
}
